import React from 'react'
import {SuspenseWhileLoading} from '@oc/components'

const RkMonitoringLogs = React.lazy(async () => ({
    default: (await import('@oc/rk-monitoring-logs/module')).RkMonitoringLogs
}))

export function RkMonitoringLogsComponent() {
    return <SuspenseWhileLoading LazyComponent={RkMonitoringLogs} />
}
